import React from 'react';
import PropTypes from 'prop-types';
import { Space, Typography } from 'antd';
import './AreaChartGraph.scss';

function AreaChartGraphTooltip({ active, payload }) {
  if (!active || !payload || payload?.length === 0) return null;

  const finalPayload = payload?.[0];
  if (!finalPayload) {
    return null;
  }

  return (
    <div className="line-chart-tooltip">
      <div className="date-box">
        <Space>
          <Space>
            <Typography.Text className="box-value">Date : </Typography.Text>
          </Space>
          <Space>
            <Typography.Text className="box-value">
              {`${finalPayload.payload?.transaction_date}`}
            </Typography.Text>
          </Space>
        </Space>
      </div>

      <div className="success-box">
        <Space>
          <Space>
            <Typography.Text className="box-value">Success : </Typography.Text>
          </Space>
          <Space>
            <Typography.Text className="box-value">
              {`${finalPayload.payload?.success_count}`}
            </Typography.Text>
          </Space>
        </Space>
      </div>

      <div className="failure-box">
        <Space>
          <Space>
            <Typography.Text className="box-value">Failure : </Typography.Text>
          </Space>
          <Space>
            <Typography.Text className="box-value">
              {`${finalPayload.payload?.failure_count}`}
            </Typography.Text>
          </Space>
        </Space>
      </div>
    </div>
  );
}

AreaChartGraphTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number
    })
  )
};
AreaChartGraphTooltip.defaultProps = {
  active: false,
  payload: []
};

export default AreaChartGraphTooltip;
